import { formatPrice } from "services/util/trips.service";
import { capitalice } from "services/util/util.service";
import { IMappingPaymentCards } from "./MyTrips.model";

export const isEmptyObject = (obj: object = {}) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}
export function getBookingsArray(data: any) {
    // CONTRATOS: Entiendo que se tiene que hacer un filter de los tickets que tengan los valores {type: mode, value: complex}
  const bodyforTickets: any[] = [];
  if (data.event != "cercanias") {
    data?.bookings?.forEach((ticket: any) => {
      if (ticket?.status != "CANCELED") {
        bodyforTickets.push(ticket?.ticketId);
        //bodyforTickets.push(ticket?.offerId);
        
      }
    });
  } else {
    data?.bookings?.forEach((ticket: any) => {
      bodyforTickets.push(ticket?.ticketId);
    });
  }
  return bodyforTickets;
}
export const getFullName = (item: any) => {
  const name = item?.personalInformation?.customerFullName?.name ? item.personalInformation.customerFullName.name : '';
  const firstSurname = item?.personalInformation?.customerFullName?.firstSurname ? item.personalInformation.customerFullName.firstSurname : '';
  const text = `${name} ${firstSurname}`.trim();
  return !!text ? text : null;
}
export function formatDateToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(sessionLanguageMapping(), { year: 'numeric', month: 'short', day: 'numeric' });
}
export function formatDateAndMonthToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(sessionLanguageMapping(), { month: 'short', day: 'numeric' });
}
export function formatWeekdayAndDateMonthToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return capitalice(dateObj.toLocaleDateString(sessionLanguageMapping(), { weekday: 'long', month: 'short', day: 'numeric' }));
}
export function sessionLanguageMapping() {
  let lenguage = "";

  if (sessionStorage.getItem('raas-language') == 'en') {
    lenguage = 'en-GB';
    //Para el valenciano se pone el catalan
  } else if (sessionStorage.getItem('raas-language') == 'va') {
    lenguage = 'ca';
  } else {
    lenguage = sessionStorage.getItem('raas-language') || "es";
  }
  return lenguage;
}
export function addZerosLeft(n: number | string) {
  n = n + '';
  return n.length >= 2 ? n : new Array(2 - n.length + 1).join('0') + n;
};
export function formatTimeToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return `${addZerosLeft(dateObj.getHours())}:${addZerosLeft(dateObj.getMinutes())}`;
}

/**
 * Para formato Zulu Sixt
 * @param date 
 * @returns 
 */
export function formatTimeToLiteralUTC(date: string) {
    //Transform '2023-12-04T13:45:00Z' to "13:45"
    if(date && date.length>17){
      const dateObj = new Date(date);
      return dateObj.toString().substring(16, 21)
        //return date.substring(11, 16);
    }
    return "00:00"
}
export function formatCompleteDateToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(sessionLanguageMapping(), { year: 'numeric', month: '2-digit', day: '2-digit' });
}


export enum  travelsType {
  TMB = 'tmb',
  TRIP = 'trip',
  GLOBICK = 'globick',
  SIXT = 'sixt'
}

export function statusMapping(state: string, t:any) {
  let result="";
  switch (state) {
      case 'PENDING_PAYMENT':    
      case 'PENDING':     
         result=t("statusMapping.pending")
        break;
      case 'BOOKED':
           result=t("statusMapping.booked")
          break;
      case 'CANCELED_NON_REFUNDED':
      case 'CANCELED':
           result=t("statusMapping.canceled")
           break;
      case 'FAILED':
         result=t("statusMapping.failed")
        break;
      case 'COMPLETED':
        result=t("statusMapping.completed")
      break;
      case 'VALID':
        result=t("statusMapping.pending")
      break;
    default:
      break;
  }
return result
}

export function stylesStatusMapping(status: string) {

  switch (status) {
     case 'VALID':
      case 'PENDING':
      case 'PENDING_PAYMENT':    
        return {
            background:'#FFFFFF',
            color:"#B38900",
            border: "#B38900"
        }
      case 'FAILED':
      case 'CANCELED_NON_REFUNDED':
      case 'CANCELED':
        return {      
            background:"#FFFFFF",     
            color:"#D04900",
            border: "#D04900"
        }
      case 'COMPLETED':
      case 'BOOKED':  
        return {
            background:'#FFFFFF',
            color:"#297570",
            border: "#297570"
        }
    default:
        return {
            background:"",
            color:"",
            border: ""
          };
  }
}

export function sixtBreakdown(t: any) {
  return{
    title: t("sixtBreakdown.title"),
    booking: t("sixtBreakdown.booking"),
    vehicle: t("sixtBreakdown.vehicle"),
    services: t("sixtBreakdown.services"),
    extras: t("sixtBreakdown.extras"),
    totalPay: t("sixtBreakdown.totalPay"),
    seeBreakdown: t("sixtBreakdown.seeBreakdown"),
    currency: t("sixtBreakdown.currency"),
    currencyDay: t("sixtBreakdown.currencyDay"),
  }
}

export function detailTags(t: any) {
  return [
    {
      code: t("detailTags.0.code"),
      text: t("detailTags.0.text"),
    },
    {
      code: t("detailTags.1.code"),
      text: t("detailTags.1.text"),
    },
  ];
}


export function getDiscountCancellationData(data: any,isPastTravel:boolean) {
  let discounts;//Descuentos
  let discountsNoString;//Descuentos
  let cancellationFees;//Gastos de cancelacion
  let cancellationRefund// Devolución de cancelacion
  let typeDiscount;
  let showBanneNoDiscount=false;

  if(data.price?.concepts){
    let filterDiscountDoco=data?.price?.concepts.find((item: any) => item.type==="DOCO_DISCOUNT" || item.name==="DOCO_DISCOUNT"|| item.type==="COUPON" || item.name==="COUPON"|| item.type==="UNKNOWN" || item.name==="UNKNOWN");
    if(filterDiscountDoco){ 
      showBanneNoDiscount=true;
      let shouldExecute =
      ((data.provider === "bolt" && isPastTravel) || 
      (data.provider !== "bolt")) &&
      filterDiscountDoco.redemptionTime; // 
      

  if (shouldExecute) { // Verificamos la condición combinada
      discounts = `-${formatPrice((filterDiscountDoco.value * -1) / 100)} €`;
      discountsNoString = (filterDiscountDoco.value * -1);
      typeDiscount = filterDiscountDoco.name;
      showBanneNoDiscount=false;
  }
       
    }
  }

  /*if(data?.cancellation?.fees){
    cancellationFees=`${formatPrice(data?.cancellation?.fees.value/100)} €`;
  }*/

  if(data?.refundList){
    cancellationRefund=`${formatPrice((data?.refundList[0].value*-1) /100)} €`;
    
  }


return{discounts,cancellationFees,cancellationRefund,discountsNoString,typeDiscount,showBanneNoDiscount}

}

export function getDiscountMapping(data: any,t:any) {
  let result="";
  switch (data) {
    case 'DOCO_DISCOUNT':
      result=t("desgloseModalLiterals.discount")
      break;
      case 'COUPON':
        result=t("desgloseModalLiterals.discount")
        break;

    case 'RENFE_DICUOUNT':
      result=t("desgloseModalLiterals.discount")
      break;
      case 'UNKNOWN':
        result=t("desgloseModalLiterals.discount")
        break;

       
  
    default:
      break;
  }
return result

}


export function getDiscount(fromToData: any,t:any) {
  let result;

  result=fromToData?.map((item: any) => {
    if(item.icon!=="ingreso" && item.icon!=="andar"&& item.icon!=="busLD"&& item.icon!=="merto"){
      if(item?.orderId?.bookings[0]?.price.concepts.length!=0 &&item?.orderId?.bookings[0]?.price.concepts!=undefined ){
        let isPost=false;
        if(item.orderId.provider==="karhoo" ||item.orderId.provider==="bolt"||item.orderId.provider==="cooltra" ||item.orderId.provider==="tier" ){
          isPost=true;
        }
        if(item?.cancelled===false){
        let filterDiscountDoco=item?.orderId?.bookings[0]?.price?.concepts.find((item: any) => item.type==="DOCO_DISCOUNT" || item.name==="DOCO_DISCOUNT" || item.type==="COUPON" || item.name==="COUPON"  || item.type==="UNKNOWN" || item.name==="UNKNOWN"  );
        if(filterDiscountDoco){ 
          return{
            value:`-${formatPrice((filterDiscountDoco.value*-1) /100)} €`,
            title:t("desgloseModalLiterals.discount"),
            id:filterDiscountDoco.name ||filterDiscountDoco.type ,
            amount:(filterDiscountDoco.value*-1) /100,
            literal:isPost===true ? t("getTripCardData.literals.approx"): ""
        }
      }
      }
      }
    }
  })

  return result

}

export function getNonRefunded(data: any) {
  let result=false;
  /*if(Object.entries(data?.outwardJourney).length!=0){
    data?.outwardJourney?.selectedTariff?.map((item: any) => { 
      result=!! item.tickets.find((item:any )=> item?.status == 'CANCELED_NON_REFUNDED') as boolean
    })
  }else{
    data?.returnJourney?.selectedTariff?.map((item: any) => { 
      result=!! item.tickets.find((item:any )=> item?.status == 'CANCELED_NON_REFUNDED') as boolean
    })
  }*/
    data?.selectedTariff?.map((item: any) => { 
      result=!! item.tickets.find((item:any )=> item?.status == 'CANCELED_NON_REFUNDED') as boolean
    })

  return result
}

const funcionCombinar= (data:any) => {

     // Obtener detalles de "Cercanias"
     const cercaniasDetails = data?.find((item:any) => item.transport === "Cercanias")?.details;
     const aveDetails = data?.find((item:any) => item.transport === "RENFE")?.details;
    let filteredData
     // Verificar si hay detalles de "Cercanias"
     if (cercaniasDetails) {
       // Actualizar el array con los detalles combinados
       const updatedData = data?.map((item:any) => {
         if (item?.transport === "AVE Larga distancia" ||item?.transport === "AVANT" ||item?.transport === "RENFE" ) {
           return {
             ...item,
             details: [...item.details, ...cercaniasDetails],
           };
         }
         return item;
       });
   
       
       if(aveDetails){
           // Filtrar para eliminar "Cercanias"
           filteredData = updatedData.filter(
            (item:any) => item.transport !== "Cercanias"
          );
          return filteredData
       }else{
        return updatedData
       }
    
      
      }else{
        return data
      }
}

export function combineRenfe(data: any) {
  let body={}
  if(Object.keys(data.arrival).length !== 0){
    body={
      arrival:{
        ...data?.arrival,
        transports:!isEmptyObject(data?.arrival?.transports) &&funcionCombinar(data?.arrival?.transports)
      },
      ...data
    }

  }else if(Object.keys(data.departure).length !== 0){
    body={
      ...data,
      departure:{
        ...data?.departure,
        transports:!isEmptyObject(data?.departure?.transports) &&funcionCombinar(data?.departure.transports)
      }
    }
  }

    return body

  }


  export function mappingPaymentCards(paymentInfo: any,status:string,provider:string,ticket:any,orderFailedReason:string,t:any) {
    //let card={} as IMappingPaymentCards
    let icon="";
    let name
    let isXpay=false

    switch (paymentInfo.paymentMethod) {
      case 'CREDIT_CARD':
      if(paymentInfo.ccType==="MASTERCARD"){
        name='MASTERCARD'
        icon='mastercard';

      }else if(paymentInfo.ccType==="VISA"){
        name='VISA'
        icon='visa';
      }
      break;
      case 'GOOGLE_PAY':
      case 'GOOGLEPAY':
        name="Pago móvil"
        icon='payMobile';
        isXpay=true;
      break;
      case 'APPLE_PAY':
      case 'APPLEPAY':
        name="Pago móvil"
        icon='payMobile';
        isXpay=true;
        break;
      case 'X_PAY':
      case 'XPAY':
        name="Pago móvil"
        icon='payMobile';
        isXpay=true;
      break;
    }
    let orderReason
if (
  (status === "FAILED" || status === "CANCELED_BY_PROVIDER") &&
  orderFailedReason !== undefined &&
  orderFailedReason !== ""
) {


  orderReason = {
    text: t(`orderFailedReasonLiterals.${orderFailedReason?.toLowerCase()}`),
    active: true
  };

} else {
  orderReason = {
    text: "",
    active: false
  };
}


    return {paymentInfo: paymentInfo.paymentMethod,icon: icon, name: name, number: paymentInfo?.digits, date: formatearFecha(paymentInfo?.expiryDate), status:status,provider:provider,ticket:ticket,text:t("initialDetailLiteralsAtom.paymentXpay"),isXpay:isXpay,orderFailedReason:orderReason }  as IMappingPaymentCards
    
  }



  function formatearFecha(fecha:string) {
    if(fecha!=undefined){

   
    // Crear un objeto Date a partir de la cadena de texto
    const fechaObj = new Date(fecha);
    // Obtener el día y el mes
    const year = fechaObj.getFullYear();
    const mes = fechaObj.getMonth() + 1; // Los meses van de 0 a 11, por eso sumamos 1
    
    // Formatear para que siempre sea de dos dígitos
    const yearFormateado = year.toString()
    const mesFormateado = mes.toString().padStart(2, '0');
    
    // Devolver la fecha en formato dd/MM
    return `${mesFormateado}/${yearFormateado.slice(2,4)}`;
  }
  }





export function mappindDesglose(journey:any, createdDate:any, travellers:any,typeTrip:string, t:any) {
  let isPastTravel=false
  if (window.location.pathname === '/app/my-past-trips') {
    isPastTravel=true
  }
  
if(journey.trip.Destination!==undefined && (journey?.selectedTariff!==undefined&&journey?.selectedTariff.length!==0)){
  return journey?.selectedTariff.map((item:any, index:any) => {
    const { discounts, cancellationFees, cancellationRefund, discountsNoString, typeDiscount,showBanneNoDiscount } = getDiscountCancellationData(item,isPastTravel);
    return {
      tripId:item.orderId,
      isPayment:true,
      date: formatDateToLiteral(createdDate),
      hour: formatTimeToLiteral(createdDate),
      cardicon: "",
      totalticket: `${formatPrice(item?.price?.totalWithOutConcepts / 100)} €`,
      totalamount: `${formatPrice(item?.price?.total / 100)} €`,
      showRequestInvoiceButton: (isPastTravel && (item.status === "CANCELED" ||item.status === "BOOKED" ||item.status === "COMPLETED" )) ? true : false,
      tripdate: formatWeekdayAndDateMonthToLiteral(journey.originDate),
      triptime: `${formatTimeToLiteral(journey.originDate)} - ${formatTimeToLiteral(journey.destinationDate)}`,
      travellers: travellers.length,
      isDisclaimer: getNonRefunded(journey),
      discount: discounts ? discounts : "",
      discountsNoString: discountsNoString ? discountsNoString : undefined,
      ...(cancellationFees ? { cancelationfee: cancellationFees } : {}),
      ...(cancellationRefund ? { cancellationRefund: cancellationRefund } : {}),
      typeDiscount: typeDiscount,
      idLeg: item.idLeg,
      typeTrip:typeTrip,
      provider:item.provider,
      showBannerDiscount: showBanneNoDiscount,
      literalBannerDiscount: t("getTripCardData.literals.noApplyDiscount"),
      literals: {
        reservationdate: t("literals.reservationdate"),
        paymethod: t("literals.paymethod"),
        summaryprice: t("literals.summaryprice"),
        totalticket: t("literals.totalticket"),
        cancelationfee: t("literals.cancelationfee"),
        discounts: t("literals.discounts"),
        paid: t("literals.paid"),
        pendingpay: t("literals.pendingpay"),
        totalamount: t("literals.totalamount"),
        approx: t("literals.approx"),
        breakdown: t("literals.breakdown"),
        cancellationRefund: t("literals.cancellationRefund"),
        discountsUNKNOWN: t("literals.discountsUNKNOWN"),
        requestInvoiceText: t("literals.requestInvoiceText"),
      },
    };
  });
}else{
  return []
}
}
 


export function filterRenfeTrip(data:any) {
    // Filtramos el primer objeto "renfe-ave" con "outwardJourney"
    const primerRenfeOutward = data
        .filter((viaje:any) => viaje.provider === 'renfe-ave' && (viaje.typeTrip === 'outwardJourney' ||viaje.typeTrip === 'returnJourney' ))
        .slice(0, 1);  // Obtenemos solo el primer elemento

    // Concatenamos el resto de los viajes que no son 'renfe-ave'
    const otrosViajes = data.filter((viaje:any) => viaje.provider !== 'renfe-ave');

    // Combinamos ambos resultados
 
    return  [...primerRenfeOutward, ...otrosViajes];
}     


export function TMBStatusMapping(status: string,payment:string,t:any) {

  let result="";
  switch (status) {
    case 'FAILED':
      result=t("getTripCardData.literals.tripFailedSuccess")
    break;
    case 'VALID':
      if(payment==="SUCCESS"){
      result=t("getTripCardData.literals.tripValidSuccess")
      }else{
        result=t("getTripCardData.literals.tripValid")
      }

    break;


  }
  return result
}




export function isFinalized(fecha:Date) {
  const fechaDestino = new Date(fecha).getTime(); // milisegundos
  const ahora = Date.now(); // milisegundos actuales
  return ahora > fechaDestino;
}





export interface Desglose {
  date:                     string | Date;
  hour:                     string | Date;
  cardicon:                 string;
  totalticket:              string;
  discount:                 object;
  discountsNoString:        number;
  paid:                     string;
  pendingpay:               string;
  totalamount:              string;
  showRequestInvoiceButton: boolean;
  cancelationfee:           object;
  cancellationRefund:       object;
  tripdate:                 string | Date;
  triptime:                  string | Date;
  travellers:               number;
  isDisclaimer:             boolean;
  typeDiscount:             string;
}

      
      
        
                    